import React, {useEffect, useState} from 'react';
import './CreateRole.css';
import CreateRoleHeader from '../CreateRoleHeader/CreateRoleHeader';
import CreateRoleInputName from '../CreateRoleInputName/CreateRoleInputName';
import RoleAssignmentPanel from '../RoleAssignmentPanel/RoleAssignmentPanel';
import {
  fetchGetGetType,
  fetchGetRight,
  sendCreateRole,
  sendUpdateRole,
} from '../../api/rolesApi';

const CreateRole = ({
  handleSelectedPopup,
  activePopup,
  checkIsAuthenticated,
  selectedItemId,
  updateTabData,
  selectedTab,
  data,
  typeAction,
  handleTypeActionClear,
}) => {
  const [name, setName] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [rights, setRights] = useState({});

  const handleChangeName = (value) => {
    setName(value);
  };

  const handleChangeFormData = ({
    sectionId,
    rightId,
    typeId,
    value,
    action,
  }) => {
    setRights((prev) => {
      if (action === 'selectAll' || action === 'deselectAll') {
        const newValue = action === 'selectAll';
        return {
          ...prev,
          [sectionId]: {
            ...prev[sectionId],
            rights: Object.fromEntries(
              Object.entries(prev[sectionId].rights).map(([rId, right]) => [
                rId,
                {
                  ...right,
                  types: Object.fromEntries(
                    Object.entries(right.types).map(([tId, type]) => [
                      tId,
                      {...type, value: newValue},
                    ])
                  ),
                },
              ])
            ),
          },
        };
      }

      // Обновление конкретного типа в праве
      return {
        ...prev,
        [sectionId]: {
          ...prev[sectionId],
          rights: {
            ...prev[sectionId].rights,
            [rightId]: {
              ...prev[sectionId].rights[rightId],
              types: {
                ...prev[sectionId].rights[rightId].types,
                [typeId]: {
                  ...prev[sectionId].rights[rightId].types[typeId],
                  value,
                },
              },
            },
          },
        },
      };
    });
  };

  const handleValidateFormData = () => {
    const errors = {};
    if (!name || name.trim().length === 0) {
      errors.name = 'Это поле обязательное';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Возвращаем true, если ошибок нет
  };

  const createRole = async () => {
    if (!handleValidateFormData()) return;

    // Формируем flat-массив data из структуры rights
    const formattedData = [];
    Object.values(rights).forEach((section) => {
      Object.entries(section.rights).forEach(([rightId, right]) => {
        Object.entries(right.types).forEach(([typeId, type]) => {
          formattedData.push({
            right_id: rightId,
            type_id: typeId,
            value: type.value ? 1 : 0,
          });
        });
      });
    });

    try {
      await sendCreateRole({
        name,
        organisation_id: selectedItemId,
        is_system: 0,
        data: formattedData,
      });

      updateTabData(selectedTab);
      handleSelectedPopup(null);
      setRights({});
      setName('');
    } catch (error) {
      console.error('Ошибка при создании роли:', error);
      setFormErrors({submit: 'Ошибка при создании роли. Попробуйте снова.'});
    }
  };

  const updateRole = async () => {
    if (!handleValidateFormData()) return;

    // Формируем flat-массив data из структуры rights
    const formattedData = [];
    Object.values(rights).forEach((section) => {
      Object.entries(section.rights).forEach(([rightId, right]) => {
        Object.entries(right.types).forEach(([typeId, type]) => {
          formattedData.push({
            id: type.role_right_id,
            value: type.value ? 1 : 0,
          });
        });
      });
    });

    try {
      await sendUpdateRole({
        id: data.id,
        name,
        organisation_id: selectedItemId,
        is_system: 0,
        data: formattedData,
      });

      updateTabData(selectedTab);
      handleSelectedPopup(null);
      setRights({});
      setName('');
    } catch (error) {
      console.error('Ошибка при обновлении роли:', error);
      setFormErrors({submit: 'Ошибка при обновлении роли. Попробуйте снова.'});
    }
  };

  const handleApplyRole = () => {
    typeAction === 'edit' ? updateRole() : createRole();
  };
  const initializeFormData = (data) => {
    if (!data) return {};

    const permissions = {};

    data.sections.forEach((section) => {
      permissions[section.id] = {
        name: section.name,
        rights: {},
      };

      section.rights.forEach((right) => {
        const typesObj = {};

        right.value?.forEach((v) => {
          typesObj[v.type_id] = {
            name: v.type_name,
            value: Number(v.value), // 0 или 1
            role_right_id: v.role_right_id,
          };
        });

        permissions[section.id].rights[right.id] = {
          name: right.name,
          types: typesObj,
        };
      });
    });

    return permissions;
  };

  useEffect(() => {
    if (data) {
      setName(String(data.name));
      const roleEdit = initializeFormData(data);
      setRights(roleEdit);
    }
  }, [data]);

  const handleCreateRoleClose = () => {
    handleSelectedPopup(null);
    handleTypeActionClear();
    setFormErrors({});
    setName('');
  };

  useEffect(() => {
    const getTabs = async () => {
      try {
        // Получаем данные о правах и типах одновременно
        const [rightsRes, typesRes] = await Promise.all([
          fetchGetRight(selectedItemId),
          fetchGetGetType(selectedItemId),
        ]);

        const typesMap = new Map(typesRes.data.map((t) => [t.id, t.types]));

        const permissions = {};

        rightsRes.data.forEach((menu) => {
          const targetTypes = typesMap.get(menu.id) ?? [];

          permissions[menu.id] = {
            name: menu.name,
            orders: menu.orders,
            rights: {},
          };

          menu.rights.forEach((right) => {
            permissions[menu.id].rights[right.id] = {
              name: right.name,
              types: {},
            };

            targetTypes.forEach((type) => {
              permissions[menu.id].rights[right.id].types[type.id] = {
                name: type.name,
                value: 0,
              };
            });
          });
        });

        setRights(permissions);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
      }
    };

    if (!data) {
      getTabs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkIsAuthenticated, activePopup]);

  return (
    <>
      <div
        onClick={handleCreateRoleClose}
        className={`overlay ${activePopup === 'roles' ? 'show' : 'hide'}`}
      ></div>
      <div className={`create-role ${activePopup === 'roles' ? 'show' : ''} `}>
        <CreateRoleHeader
          typeAction={typeAction}
          handleApplyRole={handleApplyRole}
          handleSelectedPopup={handleSelectedPopup}
          handleCreateRoleClose={handleCreateRoleClose}
        />
        <CreateRoleInputName
          error={formErrors.name}
          onChange={handleChangeName}
          name={name}
        />

        {!!Object.keys(rights)[0] && (
          <RoleAssignmentPanel
            handleChangeFormData={handleChangeFormData}
            data={rights}
          />
        )}

        {formErrors.submit && (
          <div className='error-message'>{formErrors.submit}</div>
        )}
      </div>
    </>
  );
};

export default CreateRole;
